import { render, staticRenderFns } from "./ModalBatchPurchaseOrderItemForm.vue?vue&type=template&id=b81b30d2&"
import script from "./ModalBatchPurchaseOrderItemForm.vue?vue&type=script&lang=js&"
export * from "./ModalBatchPurchaseOrderItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports